<template>
  <el-dialog
    title="题组题答题模式说明"
    width="30%"
    :before-close="handleClose"
    :visible.sync="tipParmas.tipsVisible"
    :close-on-click-modal="false"
    :show-close="false"
  >
  <el-alert
    title="特殊答题规则，请仔细阅读！"
    type="info"
    show-icon
    :closable="false">
  </el-alert>
    <div class="content" v-html="tipParmas.tipsContent" />
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="know">我已知晓</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    tipParmas: {
      type: Object,
      default() {
        return {
        }
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    handleClose() {
      this.$emit('know',2)
    },
    know() {
      this.$emit('know',2)
    },
  }
}
</script>
  <style lang="scss" scoped>
.content{
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #606060;
    line-height: 24px;
    padding: 10px 24px 16px 24px;
}
.dis_btn{
  background: #F7F8FA;
  border: none;
}
.time{
  font-size: 14px;
  color: #DD594A;
  margin-right: 8px;
}
::v-deep {
  .el-dialog__title {
    font-size: 16px;
  }
  .el-dialog__body{
    padding: 0;
  }
  .el-alert--info.is-light{
    background-color: #FFF3F0;
    color: #EB5C55;
    position: relative !important;
    top: 0 !important;
  }
}
  </style>

